import React from 'react'

const OurExpertise = () => {
    return (
        <div className=" bg-[#00101D] min-w-full">
            <div className='max-w-7xl mx-auto py-20 px-4'>
                <h2 className="text-4xl text-white text-center mb-6">Our Expertise on</h2>
                <div className="rounded-lg py-2 px-6 max-w-3xl mx-auto flex justify-center items-center flex-wrap gap-10 bg-[#2196F31A]/10">
                    {/* Technology logos */}
                    <img src="/assets/feature1-2.png" alt="technology" className="w-[100%]" />
                </div>
            </div>
        </div>
    )
}

export default OurExpertise